import React, { useState } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { Form, Input, Button } from 'antd';

const MaintenanceForm = ({
  form,
  previousData,
  submitMaintenance,
  cancelMaintenance,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();

    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        submitMaintenance(values);
      }
    });
  };

  const defaultMessage = {
    en: {
      title: "We'll be back soon!",
      body:
        "This service is currently under maintenance. Don't worry, we're doing our best and will return shortly!",
    },
    id: {
      title: 'Kami akan segera kembali!',
      body:
        'Layanan ini sedang dalam perbaikan. Jangan khawatir kami sedang melakukan yang terbaik dan akan segera kembali!',
    },
  };

  const handlePrevValue = () => {
    form.setFieldsValue({
      en: {
        title: get(previousData, 'en.title') || defaultMessage.en.title,
        body: get(previousData, 'en.body') || defaultMessage.en.body,
      },
      id: {
        title: get(previousData, 'id.title') || defaultMessage.id.title,
        body: get(previousData, 'id.body') || defaultMessage.id.body,
      },
    });
  };

  const { getFieldDecorator } = form;
  return (
    <Form id="maintenanceForm">
      <Form.Item label="Title (EN)" required colon={false}>
        {getFieldDecorator('en.title', {
          rules: [
            {
              required: true,
              message: 'Please fill this field',
            },
          ],
        })(<Input placeholder="Input Title (EN)" size="large" />)}
      </Form.Item>

      <Form.Item label="Body (EN)" required colon={false}>
        {getFieldDecorator('en.body', {
          rules: [
            {
              required: true,
              message: 'Please fill this field',
            },
          ],
        })(
          <Input.TextArea
            rows={4}
            style={{ fontSize: 16 }}
            placeholder="Enter message for maintenance page"
          />,
        )}
      </Form.Item>

      <Form.Item label="Title (ID)" required colon={false}>
        {getFieldDecorator('id.title', {
          rules: [
            {
              required: true,
              message: 'Please fill this field',
            },
          ],
        })(<Input placeholder="Input Title (ID)" size="large" />)}
      </Form.Item>

      <Form.Item label="Body (ID)" required colon={false}>
        {getFieldDecorator('id.body', {
          rules: [
            {
              required: true,
              message: 'Please fill this field',
            },
          ],
        })(
          <Input.TextArea
            rows={4}
            style={{ fontSize: 16 }}
            placeholder="Enter message for maintenance page"
          />,
        )}
      </Form.Item>

      <center className="btn-group-change">
        <Button
          id="cancelBtn"
          className="btn-close"
          type="ghost"
          onClick={cancelMaintenance}
        >
          Cancel
        </Button>
        <Button
          className="btn-save"
          id="saveBtn"
          type="primary"
          onClick={handleSubmit}
          loading={loading}
        >
          Save
        </Button>
        <Button className="btn-change" onClick={handlePrevValue}>
          Use Previous Message
        </Button>
      </center>
    </Form>
  );
};

MaintenanceForm.propTypes = {
  form: PropTypes.object,
  submitMaintenance: PropTypes.func,
  cancelMaintenance: PropTypes.func,
  previousData: PropTypes.object,
};

export default MaintenanceForm;
